const chat = {
  actions: {
    newChat: '新建会话',
    reconnect: '重新连接',
    scrollToBottom: '回到消息底部',
    send: '发送',
    stop: '停止',
  },
  attachments: {
    add: '上传附件',
    closePreview: '关闭图片预览',
    failed: '失败',
    imageAlt: '附件图片：{{name}}',
    open: '打开附件 {{name}}',
    preview: '预览附件 {{name}}',
    previewDialogTitle: '图片预览：{{name}}',
    remove: '移除附件 {{name}}',
    uploadFailed: '附件上传失败',
    uploading: '上传中',
    errors: {
      localNotAllowed: '当前应用不支持本地文件上传。',
      maxCount: '最多上传 {{count}} 个附件。',
      maxSize: '文件不能超过 {{size}} MB。',
      removeFailed: '请先移除上传失败的附件。',
      unsupportedExtension: '不支持该文件扩展名。允许：{{extensions}}。',
      unsupportedMime: '不支持该文件 MIME 类型。允许：{{mimeTypes}}。',
      unsupportedType: '不支持该文件类型。允许：{{types}}。',
      uploadFailed: '附件上传失败，请重试。',
      waitForUpload: '附件上传完成后再发送。',
    },
  },
  citations: {
    close: '关闭引用详情',
    emptyContent: '暂无可展示内容。',
    page: '第 {{page}} 页',
    sourceContent: '召回段内容',
    title: '引用',
    untitledDocument: '未命名文档',
  },
  composer: {
    hint: 'AI 可能会出错，请核对关键结果。',
    label: '输入消息',
    placeholder: '输入消息，Enter 发送，Shift + Enter 换行',
    placeholderMobile: '发消息…',
  },
  coreAgent: {
    appsErrorDescription: '暂时无法读取已安装应用，请稍后重试。',
    appsErrorTitle: '无法选择默认应用',
    disabledDescription: '管理员尚未启用 {{hubAgentName}}，或还没有配置可用模型。',
    disabledTitle: '{{hubAgentName}} 暂不可用',
    modelList: '可选模型',
    modelListDescription: '{{hubAgentName}} 会话可切换模型',
    modelSelector: '选择模型',
    modelUnavailable: '请选择一个可用模型后再发送。',
    providerAlertTitle: '{{hubAgentName}} 调用异常',
    providerUnavailable: '{{hubAgentName}} 暂时无法调用模型，请稍后重试。',
    statusErrorDescription: '暂时无法确认 {{hubAgentName}} 是否可用，请稍后重试。',
    statusErrorTitle: '无法加载 {{hubAgentName}}',
    welcomeSubtitle: '直接提问，或从左侧菜单挑一个应用开始。',
    welcomeTitle: '今天有什么可以帮你的？',
  },
  empty: {
    action: '去应用',
    description: '选择一个已安装的应用后，就可以开始新的对话。',
    title: '先选择一个应用',
  },
  errors: {
    activeRunReconnectFailed: '自动重连失败，服务端可能仍在生成。',
    forbidden: '你没有权限使用这个应用。',
    channelUnavailable: '此应用未在当前使用渠道开放。',
    generic: '请求失败，请稍后重试。',
    loadTitle: '无法加载聊天页',
    missingQuery: '请输入消息后再发送。',
    provider: '应用配置或上游服务异常，请联系管理员处理。',
    providerAlertTitle: '应用调用异常',
    retry: '重试',
    stopped: '已停止生成。',
    submissionRetryExhausted: '连接一直没有建立，请检查网络后重新发送。',
    unauthorized: '登录状态已过期，请重新登录。',
  },
  embed: {
    loadFailedDescription: '目标页面可能禁止嵌入，或当前网络无法访问。',
    loadFailedTitle: '无法加载嵌入页面',
    missingDescription: '后端没有返回可用于打开应用的 actual_url。',
    missingTitle: '应用 URL 未配置',
    preparingSession: '正在安全连接…',
    reload: '重新加载',
    sessionFailedDescription: '暂时无法打开应用，请重试。',
    sessionFailedTitle: '无法建立单点登录',
    startingApplication: '正在启动…',
  },
  header: {
    breadcrumbLabel: '页面层级',
    breadcrumbRoot: '应用',
    existingConversation: '历史会话',
    loadingApp: '正在加载应用',
    newConversation: '新会话',
  },
  history: {
    cancel: '取消',
    confirm: '确定',
    delete: '删除',
    deleteAction: '删除 {{title}}',
    deleteDialogDescription: '已选择的会话将被永久删除，不可恢复及撤销。',
    deleteDialogTitle: '删除会话',
    emptyDescription: '开始一次新对话后，这里会显示当前应用的历史记录。',
    emptyTitle: '暂无历史会话',
    groups: {
      all: '全部',
      earlier: '更早',
      thisMonth: '本月',
      thisYear: '今年',
      today: '今天',
    },
    loadMore: '加载更多',
    noResultsDescription: '换个关键词试试。',
    noResultsTitle: '没有匹配的会话',
    pinAction: '置顶 {{title}}',
    rename: '修改名称',
    renameAction: '修改 {{title}} 名称',
    renameDialogTitle: '修改会话名称',
    renameLabel: '会话名称',
    renamePlaceholder: '输入会话名称',
    searchLabel: '搜索历史会话',
    searchPlaceholder: '搜索历史会话',
    searchPlaceholderMobile: '在已加载的会话中筛选',
    title: '历史会话',
    unpinAction: '取消置顶 {{title}}',
  },
  messages: {
    closeViewer: '关闭',
    codeCopied: '代码已复制。',
    contentCopied: '内容已复制到剪贴板。',
    copyAnswer: '复制回答',
    copyCode: '复制代码',
    copyFailed: '复制失败，请手动复制。',
    copyUserMessage: '复制用户消息',
    downloadDiagram: '下载图表',
    downloadDiagramAsMmd: '下载为 MMD',
    downloadDiagramAsPng: '下载为 PNG',
    downloadDiagramAsSvg: '下载为 SVG',
    downloadFile: '下载文件',
    echartsInvalidOption: '无法渲染图表，请检查 ECharts JSON 配置。',
    echartsLoading: '正在渲染图表...',
    echartsPreview: '预览',
    echartsSource: '源码',
    echartsViewMode: '切换 ECharts 显示模式',
    emptyHistory: '这个会话暂时没有可展示的消息。',
    exitFullscreen: '退出全屏',
    dislikeAnswer: '点踩回答',
    feedbackCleared: '已取消这次反馈。',
    feedbackDisliked: '收到，我们会认真改进。',
    feedbackFailed: '反馈提交失败，请稍后重试。',
    feedbackLiked: '谢谢反馈，很高兴帮上忙。',
    latexLoading: '正在渲染 LaTeX...',
    latexPreview: '预览',
    latexSource: '源码',
    latexViewMode: '切换 LaTeX 显示模式',
    likeAnswer: '点赞回答',
    mermaidFormatMmd: 'MMD',
    mermaidFormatPng: 'PNG',
    mermaidFormatSvg: 'SVG',
    thinking: '思考中...',
    thinkingPlaceholder: '正在整理思路...',
    thoughtDone: '已思考',
    thought: '思考过程',
    thoughtDuration: '用时 {{duration}}',
    thoughtDurationSeconds: '{{seconds}} 秒',
    workflowElapsedMs: '{{ms}} ms',
    workflowElapsedSeconds: '{{seconds}} s',
    workflowNoSteps: '暂无步骤详情',
    workflowProcess: '工作流',
    workflowStepFallback: '未命名步骤',
    workflowToggle: '展开或收起工作流步骤',
    workflowTokens: '{{count}} tokens',
    viewFullscreen: '全屏查看',
    workflowStatus: {
      failed: '失败',
      paused: '已暂停',
      running: '运行中',
      stopped: '已停止',
      succeeded: '成功',
      waiting: '等待中',
    },
  },
  opening: {
    starters: '你可以这样开始',
  },
  suggestions: {
    label: '建议问题',
  },
  toolActivity: {
    completed: '使用了 {{count}} 个工具',
    detailCopied: '已复制',
    detailCopy: '复制',
    detailInput: '输入',
    detailLoadFailed: '调用详情暂不可用，可能已过期，请稍后重试。',
    detailLoading: '正在加载调用详情…',
    detailOutput: '输出',
    failedCount: '{{count}} 个失败',
    progressLabel: '{{name}} 的执行进度',
    running: '正在使用工具：{{name}}',
    status: {
      cancelled: '已取消',
      error: '失败',
      running: '执行中',
      success: '已完成',
      unknown: '结果不确定',
    },
    title: '工具调用',
    unnamed: '工具',
  },
  sidebar: {
    conversationActions: '{{title}} 的更多操作',
    deleteConversation: '删除',
    empty: '暂无历史会话',
    loading: '加载会话中',
    pickApp: '选择应用后显示会话',
    pinConversation: '置顶会话',
    pinnedConversation: '{{title}} 已置顶',
    renameConversation: '重命名',
    untitled: '未命名会话',
    unpinConversation: '取消置顶',
    viewAll: '查看全部',
  },
  startForm: {
    close: '关闭聊天设置',
    description: '补充运行所需信息后开始对话。',
    edit: '编辑',
    optional: '可选',
    required: '请填写 {{label}}。',
    submit: '提交开始信息',
    submitted: '开始信息已提交',
    title: '聊天设置',
  },
  voice: {
    cancel: '取消语音输入',
    recording: '正在聆听...',
    requestingPermission: '正在请求麦克风权限',
    start: '语音输入',
    stop: '停止录音',
    transcribing: '正在识别语音',
    errors: {
      deviceUnavailable: '未检测到可用麦克风，请检查设备后重试。',
      emptyRecording: '没有识别到语音内容，请重新录制。',
      permissionDenied: '无法访问麦克风，请在浏览器权限中允许麦克风。',
      unsupportedApp: '当前应用不支持语音输入。',
      unsupportedBrowser: '当前浏览器不支持录音输入。',
    },
  },
  workflow: {
    clear: '清空',
    collapseResult: '收起结果',
    copyResult: '复制结果',
    empty: '填写左侧参数后点击运行。',
    errors: {
      runFailed: '工作流运行失败，请查看运行过程或重试。',
    },
    result: '运行结果',
    run: '运行',
    status: {
      failed: '运行失败',
      running: '运行中',
      stopped: '已停止',
      succeeded: '运行完成',
    },
    stop: '停止',
    failedBarLabel: '运行失败 · 查看详情',
    stoppedBarLabel: '已停止 · 查看过程',
    viewResult: '查看结果',
  },
}

export default chat
